<template>
    <li class="preview-list-item">
        <div class="font-normal_medium mb-2 flex justify-between gap-2">
            <div class="text-lg">
                {{ discipline?.Name }}
            </div>
            <a
                class="text-brand-secondary font-normal_regular ml-auto mr-2 flex items-center gap-1 text-sm hover:underline"
                :href="hrefToStandings"
                target="_parent"
            >
                {{ $getStrByLng().LABEL_SEE_STANDINGS }}
                <FontAwesomeIcon class="text-xs" :icon="faAngleDoubleRight"></FontAwesomeIcon>
            </a>
        </div>
        <div class="flex flex-col gap-1">
            <div
                v-for="athlete in disciplineAthletes"
                :key="athlete.Id"
                class="border-brand bg-surface max-mobile:items-stretch flex items-center gap-3 border py-1 pr-3"
            >
                <div
                    class="font-normal_medium border-r-brand-tertiary max-mobile:flex max-mobile:justify-center max-mobile:items-center w-10 min-w-10 border-r-2 text-center text-xl"
                >
                    {{ athlete.Rank }}
                </div>
                <div class="max-mobile:flex-col flex flex-1">
                    <div class="font-normal_medium flex-1 text-left text-base">
                        <div class="flex">
                            <NocFlag class="mr-1" :nat-code="athlete.Nat" />
                            <WdlArchiveName :competitor="athlete"></WdlArchiveName>
                        </div>
                    </div>
                    <div class="max-mobile:flex-row-reverse max-mobile:justify-end flex items-center">
                        <div class="text-content/60 max-mobile:text-left w-16 min-w-16 text-right text-xs">
                            {{ athlete.Qual ? "Q" : "" }}
                        </div>
                        <div class="max-mobile:text-left w-16 min-w-16 text-right text-base uppercase">
                            {{ athlete.Points }} pts
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </li>
</template>

<script setup lang="ts">
import { faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons";
import { computed } from "vue";

import { IDiamondRaceDiscipline } from "../interfaces/wdl-archive.interfaces";
import NocFlag from "./elements/NocFlag.vue";
import WdlArchiveName from "./elements/WdlArchiveName.vue";

const props = withDefaults(
    defineProps<{
        discipline?: IDiamondRaceDiscipline;
    }>(),
    {}
);

const disciplineAthletes = computed(() => props.discipline?.Athletes?.slice(0, 5));

// The standings-preview-page is rendered in an iframe on the main page (diamondleague.com) and on the meeting-pages subdomains (MEETING.diamondleague.com).
// The link on the standings-preview-page should always link to the result-standings-page embedded on the main page (diamondleague.com)
const hrefToStandings = computed(() => "https://www.diamondleague.com/results-standings/standings/");
</script>

<style lang="scss"></style>
